import type { Apple, Embed } from '@tunasong/models'
import type { EmbedSizes } from './types.js'

/** Example URLs
https://music.apple.com/no/song/what-was-that/1809638075

<iframe allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write" frameborder="0" height="175" style="width:100%;max-width:660px;overflow:hidden;border-radius:10px;" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation" src="https://embed.music.apple.com/no/song/what-was-that/1809638075"></iframe>
 */

const urlMatch = /^https:\/\/music\.apple\.com\/(.*\/)?(\w+)\/.*\/([\w.]+)(\?.*)?$/
const iFrameMatch = /^\<iframe.*src=\"https:\/\/embed.music.apple.com\/(.*\/)?(\w+)\/.*\/([\w.]+)"/

const sizes: EmbedSizes = {
  small: {
    width: '50%',
    height: '150px',
  },
  medium: {
    width: '100%',
    height: '150px',
  },
  large: {
    width: '100%',
    height: '300px',
  },
}

export const parseTidalLink = (urlOrUrn?: string): Embed | null => {
  if (!urlOrUrn) {
    return null
  }
  const trimmed = urlOrUrn.trim()
  const match = trimmed.match(urlMatch) ?? trimmed.match(iFrameMatch)
  const mediaType = match?.[2] as string | undefined
  const mediaId = match?.[3]
  if (!(mediaId && mediaType)) {
    return null
  }

  const node: Apple = {
    type: 'embed',
    service: 'apple',
    url: `https://embed.music.apple.com/${mediaType}/${mediaId}`,
    mediaId,
    size: 'medium',
    children: [{ text: '' }],
  }
  return node
}
/**
 * <iframe src="https://embed.tidal.com/tracks/427786828" width="500" height="120" allow="encrypted-media" sandbox="allow-same-origin allow-scripts allow-forms allow-popups" title="TIDAL Embed Player" />

 */

export default {
  parse: parseTidalLink,
  sizes,
}
